import { EMPTY_LIST } from '../../../../constants/common'
import {
  TaskStatusType,
  TaskTableItemCommitType,
  TaskTableRow,
} from '../../../Task'
import { Container } from '../../Container'
import { getTableRowData, TABLE_ROW_VISIBLE_COLUMNS } from '../Tasks.mocks'

function TasksTableRow() {
  return (
    <>
      <Container label='Task table row, without actions, all columns'>
        <TaskTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData()}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Task table row, without actions, all columns, done'>
        <TaskTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData({ done: true })}
          selected={EMPTY_LIST}
        />
      </Container>
      <Container label='Task table row, without actions, all columns, yes\no answered No'>
        <TaskTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData({
            commit_type: TaskTableItemCommitType.YesNo,
            yesno: TaskStatusType.No,
          })}
          selected={EMPTY_LIST}
        />
      </Container>
    </>
  )
}

export default TasksTableRow
